import styled from 'styled-components'

const FooterStyled = styled.div`
  text-align: center;
  font-size: 14px;
  margin-top: 44px;
  margin-bottom: 4px;
`

function Footer() {
  return (
    <FooterStyled>© 2022 Nicholas Ulricksen</FooterStyled>
  )
}

export default Footer
